const Initiatives = () => {
    return (
        <div>

        </div>
    )
}

export default Initiatives;